module.exports = __webpack_public_path__ + "static/data_bar_3-d7e51676eb4b79848e10d34c45de3305.png";